import React from 'react';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';

const PhoneField = ({ label, value, onChange, disabled, required, placeholder }) => {
  return (
    <div className="phone-field-wrapper" style={{ width : "100%" }}>
      {label && (
        <label style={{ 
          display: 'block', 
          marginBottom: '5px', 
          fontSize: '12px', 
          fontWeight: '600', 
          color: '#4b5563',
          textTransform: 'uppercase'
        }}>
          {label} {required && <span style={{ color: '#ef4444' }}>*</span>}
        </label>
      )}
      <PhoneInput
        country={'in'}
        value={value}
        onChange={(phone) => onChange('+' + phone)}
        disabled={disabled}
        placeholder={placeholder || "Enter phone number"}
        inputStyle={{
          width: '100%',
          height: '32px',
          fontSize: '13px',
          borderRadius: '0px',
          border: '1px solid #ccc',
        }}
        buttonStyle={{
          borderRadius: '0px',
          border: '1px solid #ccc',
          borderRight: 'none',
          backgroundColor: '#f9fafb',
        }}
        containerStyle={{
          width: '100%',
        }}
        dropdownStyle={{
          fontSize: '12px',
          borderRadius: '0px',
        }}
        enableSearch={true}
        disableSearchIcon={false}
      />
    </div>
  );
};

export default PhoneField;
